import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

// Import environment
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AnnouncementService {

  constructor(
    private http: HttpClient,
  ) { }

  getLearnPage() {
    return this.http.get(environment.userApiUrl + 'api/admin/learnPage')
  }

  getAll(params: any) {
    return this.http.get(environment.userApiUrl + 'api/user/announcement', { params })
  }
  getAllOffers = (params: any) => {
    return this.http.get(environment.userApiUrl + 'api/admin/earn-offers', { params })
  }
    getLearnPageById = (id: any) => {
    return this.http.get(environment.userApiUrl + 'api/admin/LearnPageById/' + id)
  }
}
